// extracted by mini-css-extract-plugin
export var copyableField = "_q1-4";
export var customerBadge = "_q1-0";
export var customerInfoTitle = "_q1-2";
export var details = "_q1-1";
export var dropdownContainer = "_q1-5";
export var dropdownImage = "_q1-6";
export var editAssigneeForm = "_q1-a";
export var editButton = "_q1-3";
export var email = "_q1-7";
export var hidden = "_q1-d";
export var input = "_q1-8";
export var saveButton = "_q1-b";
export var shopifyIcon = "_q1-c";
export var suggestionBadge = "_q1-e";
export var suggestionText = "_q1-f";
export var username = "_q1-9";